import React, { useEffect, useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Button from "@mui/material/Button";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

import {
  Box,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Grid,
  FormControl,
  Select,
  MenuItem,
  InputAdornment,
} from "@mui/material";

import AttachmentRed from "../../images/attachment-red.svg";
import AttachmentGreen from "../../images/attachment-green.svg";
import Download from "../../images/Download.svg";
import Print from "../../images/Print.svg";
import { INVOICE_LIST } from "../../constants/RoutePath";
import { useLocation } from "react-router-dom";
import { jsPDF } from "jspdf";
import { AccountCircle } from "@mui/icons-material";
import pdfMainLogo from "../../images/HOS-preview-logo.svg";
import Paper from "@mui/material/Paper";
import {
  GET_INVOICE_REPORT_URL,
  GET_REPOT_BILLING_STATEMENT,
} from "../../constants/ApiRoute";
import API from "../comman/API";
import { deCryptFun, enCryptFun } from "../comman/CustomFunction";
import { authHeader, getStatementId } from "../comman/MainFunction";
const moment = require("moment");
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import axios from "axios";
import ReactApexChart from "react-apexcharts";
import dayjs from "dayjs";

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url
).toString();

// const doc = new jsPDF();
// doc.text("Hello world!", 10, 10);
// doc.save("a4.pdf");

export default function PrintBrokerView(props) {
  const pdfExportComponent = React.useRef(null);

  const [age, setAge] = React.useState("");
  const pathname = window.location.pathname;
  const parts = pathname.split("/");
  const lastPart = parts[parts.length - 1];
  let invoiceid = isNaN(lastPart) ? null : lastPart;

  const [numPages, setNumPages] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [scale, setScale] = useState(1.0);

  const pdfUrl = "http://localhost:3000/na2.pdf";
  //const pdfUrl = "https://hosv2dev.blob.core.windows.net/hosv2dev/na2_2024-07-13-19-23-22.pdf";

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setPageNumber(1); // Start at the first page
  }

  useEffect(() => {
    if (invoiceid) {
      getInvoicePrintViewDetail(invoiceid);
    }
  }, [invoiceid]);

  useEffect(() => {
    getReportBillStatementId();
  }, []);

  const getReportBillStatementId = async () => {
    let data = {
      billingStatementId: getStatementId(),
    };

    const config = {
      method: "GET",
      url: GET_REPOT_BILLING_STATEMENT,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);

      console.log(parsedResponse);

      if (parsedResponse.data && parsedResponse.data.length > 0) {
        // console.log("hi==>" )
        // var doc = new jsPDF();
        // doc.addImage("http://localhost:3000/public/logo.svg", "SVG", 15, 40, 180, 180);
        // doc.save();
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
      }
      return null; // Return null on error
    }
  };
  const getInvoicePrintViewDetail = async (invoiceid) => {
    let data = {
      invoiceId: invoiceid,
    };

    const config = {
      method: "GET",
      url: GET_INVOICE_REPORT_URL,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);

      console.log(parsedResponse);

      if (parsedResponse.data && parsedResponse.data.length > 0) {
        // console.log("hi==>" )
        // var doc = new jsPDF();
        // doc.addImage("http://localhost:3000/public/logo.svg", "SVG", 15, 40, 180, 180);
        // doc.save();
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
      }
      return null; // Return null on error
    }
  };

  const handleChange = (event) => {
    setAge(event.target.value);
  };
  const genPdf = async () => {
    var doc = new jsPDF({
      orientation: "p",
      unit: "pt",
      // format: [800,1750],
      format: "a4",
      compress: true,
      // putOnlyUsedFonts: true,
    });
    const content = document.getElementById("samplechk");
    console.log("conten", content);
    // const content1 = document.querySelector("#samplechk");
    //  doc.fromHTML(content.html(), 15, 15);
    doc.save("output.pdf");

    // pdf.setFontSize(20);
    // pdf.text(`${projectName}`, 20, 120);
    // pdf.text(`${strReportDesc}`, 20, 130);
    // pdf.text(`Due Date:${dueDateFormat}`, 20, 140);
    // pdf.addImage(orgLogo ? orgLogo.zLogoURL : "", "JPEG", 20, 150, 50, 20);
    // pdf.setFontSize(12);
  };
  const handleChanges = (event) => {
    setAge(event.target.value);
  };

  const [options, setOptions] = useState({
    chart: {
      type: "donut",
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
  });

  const [series, setSeries] = useState([44, 55, 41, 17]);

  const colors = [
    "#008FFB",
    "#00E396",
    "#FEB019",
    "#FF4560",
    "#775DD0",
    "#546E7A",
    "#26A69A",
    "#D10CE8",
  ];

  const [seriess] = useState([
    {
      data: [21, 22, 10, 28, 16, 21, 13, 30],
    },
  ]);

  const [optionss] = useState({
    chart: {
      type: "bar",
      events: {
        click: function (chart, w, e) {
          // console.log(chart, w, e)
        },
      },
    },
    colors: colors,
    plotOptions: {
      bar: {
        columnWidth: "45%",
        // Remove distributed: true
      },
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: false,
    },
    xaxis: {
      categories: [
        ["John", "Doe"],
        ["Joe", "Smith"],
        ["Jake", "Williams"],
        "Amber",
        ["Peter", "Brown"],
        ["Mary", "Evans"],
        ["David", "Wilson"],
        ["Lily", "Roberts"],
      ],
      labels: {
        style: {
          colors: colors,
          fontSize: "12px",
        },
      },
    },
    responsive: [
      {
        breakpoint: 768,
        options: {
          chart: {
            width: "100%",
          },
          plotOptions: {
            bar: {
              columnWidth: "55%",
            },
          },
        },
      },
    ],
  });

  return (
    <div id="samplechk">
      <Box sx={{ display: "-webkit-box" }}>
        <Box component="main" sx={{ flexGrow: 1, p: "18px 20px" }}>
          <Box className="bg-box invoicepdfbg-box">
            <Grid className="pdf-top-header" container spacing={2}>
              <Grid
                sx={{ pt: "0px !important", my: "auto" }}
                item
                xs={12}
                md={7}
              >
                <Stack alignItems="center" direction="row" spacing={2}>
                  <span
                    className="material-symbols-outlined"
                    disabled={pageNumber <= 1}
                    onClick={() => setPageNumber(1)}
                  >
                    skip_previous
                  </span>
                  <span
                    className="material-symbols-outlined"
                    disabled={pageNumber >= numPages}
                    onClick={() => setPageNumber(pageNumber - 1)}
                  >
                    chevron_left
                  </span>
                  <span className="pagination-text active-num">
                    {pageNumber}
                  </span>
                  <span className="pagination-text">of {numPages}</span>
                  <span
                    className="material-symbols-outlined"
                    disabled={pageNumber >= numPages}
                    onClick={() => setPageNumber(pageNumber + 1)}
                  >
                    chevron_right
                  </span>
                  <span
                    className="material-symbols-outlined"
                    disabled={pageNumber >= numPages}
                    onClick={() => setPageNumber(numPages)}
                  >
                    skip_next
                  </span>
                  <span className="material-symbols-outlined reload-pdf">
                    refresh
                  </span>
                  <span className="material-symbols-outlined">arrow_back</span>
                </Stack>
              </Grid>
              <Grid sx={{ pt: "0px !important" }} item xs={12} md={5}>
                <Stack direction="row" spacing={0}>
                  <FormControl className="whole-select" fullWidth>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={age}
                      onChange={handleChange}
                    >
                      <MenuItem value={10}>All Select</MenuItem>
                      <MenuItem value={20}>Twenty</MenuItem>
                      <MenuItem value={30}>Thirty</MenuItem>
                    </Select>
                  </FormControl>
                  <FormControl className="saveas-btn" fullWidth>
                    <Select
                      id="demo-simple-select"
                      value="pdf"
                      startAdornment={
                        <InputAdornment position="start">
                          <span className="material-symbols-outlined">
                            save
                          </span>
                        </InputAdornment>
                      }
                      onChange={handleChanges}
                    >
                      <MenuItem selected value={10} onClick={genPdf}>
                        PDF
                      </MenuItem>
                      <MenuItem value={20}>EXCEL</MenuItem>
                      <MenuItem value={20}>DOC</MenuItem>
                    </Select>
                  </FormControl>
                  <Button className="primary-btn save-print-btn">
                    <span className="material-symbols-outlined">print</span>
                  </Button>
                </Stack>
              </Grid>
            </Grid>
            <Stack
              sx={{ mt: "27px" }}
              direction="row"
              justifyContent="space-between"
              spacing={2}
            >
              <img src={pdfMainLogo} />
            </Stack>
            <hr style={{ border: "1px solid #E3E5E8", margin: "20px 0px" }} />
            <Grid container>
              <Grid item xs={12} md={6}>
                <Typography className="address-title">
                  PROJECT BILLING ROLLUP:
                </Typography>
                <Typography className="address-text">
                  5018: Villa housing community
                </Typography>
              </Grid>
              <Grid sx={{ textAlign: "right" }} item xs={12} md={6}>
                <Box
                  sx={{
                    borderRight: "4px solid green",
                    paddingRight: "10px",
                    mt: "auto !important",
                    mb: "auto !important",
                  }}
                >
                  <Typography className="total-due">TOTAL HOURS:</Typography>
                  <Typography className="total-amount">
                    74.00 hours over 45 days
                  </Typography>
                </Box>
              </Grid>
            </Grid>
            <Grid spacing={2} sx={{ mt: "30px" }} container>
              <Grid item xs={12} md={4}>
                <Box className="statement-box">
                  <Typography className="stm-title">Open</Typography>
                  <Typography className="stm-text">statement count</Typography>
                  <Typography className="stm-count">0</Typography>
                </Box>
              </Grid>
              <Grid item xs={12} md={4}>
                <Box className="statement-box">
                  <Typography className="stm-title">Closed</Typography>
                  <Typography className="stm-text">statement count</Typography>
                  <Typography className="stm-count">2</Typography>
                </Box>
              </Grid>
              <Grid item xs={12} md={4}>
                <Box className="statement-box">
                  <Typography className="stm-title">Late</Typography>
                  <Typography className="stm-text">statement count</Typography>
                  <Typography className="stm-count">3</Typography>
                </Box>
              </Grid>
              <Grid item xs={12} md={4}>
                <Box className="statement-box">
                  <Typography className="stm-title">Brokers</Typography>
                  <Typography className="stm-text">broker count</Typography>
                  <Typography className="stm-count">2</Typography>
                </Box>
              </Grid>
              <Grid item xs={12} md={4}>
                <Box className="statement-box">
                  <Typography className="stm-title">Statements</Typography>
                  <Typography className="stm-text">statement count</Typography>
                  <Typography className="stm-count">5</Typography>
                </Box>
              </Grid>
              <Grid item xs={12} md={4}>
                <Box className="statement-box">
                  <Typography className="stm-title">Total Hours</Typography>
                  <Typography className="stm-text">
                    total owned to broker
                  </Typography>
                  <Typography className="stm-count">34.00</Typography>
                </Box>
              </Grid>
            </Grid>
            <Grid spacing={2} sx={{ mt: "30px" }} container>
              <Grid item xs={12} md={4}>
                <Typography className="dash-chart-title">
                  Hours Billed Per Billing Type
                </Typography>
                <div id="chart">
                  <ReactApexChart
                    style={{ minHeight: "160px" }}
                    options={options}
                    series={series}
                    type="donut"
                  />
                </div>
                <div id="html-dist"></div>
              </Grid>
              <Grid item xs={12} md={8}>
                <Typography className="dash-chart-title">
                  Hours Billed Per Billing Type
                </Typography>
                <div id="chart">
                  <ReactApexChart
                    options={optionss}
                    series={seriess}
                    type="bar"
                    height={300}
                  />
                </div>
                <div id="html-dist"></div>
              </Grid>
            </Grid>
            <Typography
              sx={{ marginTop: "5px !important" }}
              className="billing-summary-title"
            >
              Broker Billing Summary
            </Typography>
            <TableContainer
              sx={{ minHeight: "270px" }}
              className="preview-table summary-table"
              component={Paper}
            >
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>Date</TableCell>
                    <TableCell>Type</TableCell>
                    <TableCell>Hours</TableCell>
                    <TableCell>Miles</TableCell>
                    <TableCell>Lodging</TableCell>
                    <TableCell>Copies</TableCell>
                    <TableCell>Misc</TableCell>
                    <TableCell sx={{ minWidth: "54px" }}>Per Diem</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell>
                      <span>4/1/2024</span>
                      <br />
                      <span className="pv-discription">No Description</span>
                    </TableCell>
                    <TableCell>Curative</TableCell>
                    <TableCell>3.00</TableCell>
                    <TableCell>3.00</TableCell>
                    <TableCell>$0.00</TableCell>
                    <TableCell>$0.00</TableCell>
                    <TableCell>$0.00</TableCell>
                    <TableCell>$0.00</TableCell>
                  </TableRow>
                  <TableRow
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell>
                      <span>4/1/2024</span>
                      <br />
                      <span className="pv-discription">No Description</span>
                    </TableCell>
                    <TableCell>Curative</TableCell>
                    <TableCell>3.00</TableCell>
                    <TableCell>3.00</TableCell>
                    <TableCell>$0.00</TableCell>
                    <TableCell>$0.00</TableCell>
                    <TableCell>$0.00</TableCell>
                    <TableCell>$0.00</TableCell>
                  </TableRow>
                  <TableRow
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell>Total</TableCell>
                    <TableCell></TableCell>
                    <TableCell>3.00</TableCell>
                    <TableCell>3.00</TableCell>
                    <TableCell>$0.00</TableCell>
                    <TableCell>$0.00</TableCell>
                    <TableCell>$0.00</TableCell>
                    <TableCell>$0.00</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
            <Typography className="broker-preview-title">
              Broker Test gabrielv+broker@apptomate.co 111-222-3333
            </Typography>
            <TableContainer
              sx={{
                // minHeight: "300px",
                borderRadius: "5px",
                border: "1px solid #EDEDED",
                mt: "10px",
                mb: "15px",
              }}
              className="preview-table"
              component={Paper}
            >
              <Stack
                sx={{ padding: "10px 14px" }}
                direction="row"
                alignItems="center"
                justifyContent="space-between"
              >
                <Typography
                  className="summary-table-intext"
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <span
                    style={{ color: "#58A84A", marginRight: "4px" }}
                    class="material-symbols-outlined"
                  >
                    calendar_month
                  </span>
                  4/1/2024 - 4/10/2024
                </Typography>
                <Typography className="summary-table-intext">
                  Statement ID: 109 - Invoice Started
                </Typography>
              </Stack>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>Date</TableCell>
                    <TableCell>Type</TableCell>
                    <TableCell>Hours</TableCell>
                    <TableCell>Miles</TableCell>
                    <TableCell>Lodging</TableCell>
                    <TableCell>Copies</TableCell>
                    <TableCell>Misc</TableCell>
                    <TableCell sx={{ minWidth: "54px" }}>Per Diem</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell>
                      <span>4/1/2024</span>
                      <br />
                      <span className="pv-discription">No Description</span>
                    </TableCell>
                    <TableCell>Curative</TableCell>
                    <TableCell>3.00</TableCell>
                    <TableCell>3.00</TableCell>
                    <TableCell>$0.00</TableCell>
                    <TableCell>$0.00</TableCell>
                    <TableCell>$0.00</TableCell>
                    <TableCell>$0.00</TableCell>
                  </TableRow>
                  <TableRow
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell>
                      <span>4/1/2024</span>
                      <br />
                      <span className="pv-discription">No Description</span>
                    </TableCell>
                    <TableCell>Curative</TableCell>
                    <TableCell>3.00</TableCell>
                    <TableCell>3.00</TableCell>
                    <TableCell>$0.00</TableCell>
                    <TableCell>$0.00</TableCell>
                    <TableCell>$0.00</TableCell>
                    <TableCell>$0.00</TableCell>
                  </TableRow>
                  <TableRow
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell>Total</TableCell>
                    <TableCell></TableCell>
                    <TableCell>3.00</TableCell>
                    <TableCell>3.00</TableCell>
                    <TableCell>$0.00</TableCell>
                    <TableCell>$0.00</TableCell>
                    <TableCell>$0.00</TableCell>
                    <TableCell>$0.00</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
            <TableContainer
              sx={{
                // minHeight: "300px",
                borderRadius: "5px",
                border: "1px solid #EDEDED",
                mt: "10px",
                mb: "15px",
              }}
              className="preview-table"
              component={Paper}
            >
              <Stack
                sx={{ padding: "10px 14px" }}
                direction="row"
                alignItems="center"
                justifyContent="space-between"
              >
                <Typography
                  className="summary-table-intext"
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <span
                    style={{ color: "#58A84A", marginRight: "4px" }}
                    class="material-symbols-outlined"
                  >
                    calendar_month
                  </span>
                  4/1/2024 - 4/10/2024
                </Typography>
                <Typography className="summary-table-intext">
                  Statement ID: 109 - Invoice Started
                </Typography>
              </Stack>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>Date</TableCell>
                    <TableCell>Type</TableCell>
                    <TableCell>Hours</TableCell>
                    <TableCell>Miles</TableCell>
                    <TableCell>Lodging</TableCell>
                    <TableCell>Copies</TableCell>
                    <TableCell>Misc</TableCell>
                    <TableCell sx={{ minWidth: "54px" }}>Per Diem</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell>
                      <span>4/1/2024</span>
                      <br />
                      <span className="pv-discription">No Description</span>
                    </TableCell>
                    <TableCell>Curative</TableCell>
                    <TableCell>3.00</TableCell>
                    <TableCell>3.00</TableCell>
                    <TableCell>$0.00</TableCell>
                    <TableCell>$0.00</TableCell>
                    <TableCell>$0.00</TableCell>
                    <TableCell>$0.00</TableCell>
                  </TableRow>
                  <TableRow
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell>
                      <span>4/1/2024</span>
                      <br />
                      <span className="pv-discription">No Description</span>
                    </TableCell>
                    <TableCell>Curative</TableCell>
                    <TableCell>3.00</TableCell>
                    <TableCell>3.00</TableCell>
                    <TableCell>$0.00</TableCell>
                    <TableCell>$0.00</TableCell>
                    <TableCell>$0.00</TableCell>
                    <TableCell>$0.00</TableCell>
                  </TableRow>
                  <TableRow
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell>Total</TableCell>
                    <TableCell></TableCell>
                    <TableCell>3.00</TableCell>
                    <TableCell>3.00</TableCell>
                    <TableCell>$0.00</TableCell>
                    <TableCell>$0.00</TableCell>
                    <TableCell>$0.00</TableCell>
                    <TableCell>$0.00</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
            <Typography className="address-bar">
              © 2024. HOS Resources, LLC. All Rights Reserved. 910 Harding
              Street Lafayette, LA 70503 337-296-8032 www.hosresources.com
            </Typography>
            <Stack
              direction="row"
              spacing={2}
              alignItems="center"
              justifyContent="space-between"
              className="preview-footer"
            >
              <Box>
                <Stack direction="row" spacing={1} alignItems="flex-start">
                  <span class="material-symbols-outlined">location_on</span>
                  <Typography>
                    910 Harding Street <br />
                    Lafayette, LA 70503
                  </Typography>
                </Stack>
              </Box>
              <Box>
                <Stack direction="row" spacing={1} alignItems="flex-start">
                  <span class="material-symbols-outlined">mail</span>
                  <Typography>
                    P.O. Box 51794 <br />
                    Lafayette, LA 70505
                  </Typography>
                </Stack>
              </Box>
              <Box>
                <Stack direction="row" spacing={1} alignItems="center">
                  <span class="material-symbols-outlined">call</span>
                  <Typography>337.889.8941</Typography>
                </Stack>
              </Box>
              <Box>
                <Stack direction="row" spacing={1} alignItems="center">
                  <span class="material-symbols-outlined">public</span>
                  <Typography>www.hosresources.com</Typography>
                </Stack>
              </Box>
            </Stack>
          </Box>
        </Box>
      </Box>
    </div>
  );
}
